import {
  API_ENDPOINTS,
  API_ENV_URLS,
  API_ERROR_MESSAGES,
} from "../constants/api";
import { apiFetch, getRequiredUsernameHeader } from "./apiClient";

export async function fetchEligibilityCheckList({
  filter = "awaited",
  page = 1,
  limit = 10,
} = {}) {
  const params = new URLSearchParams();

  if (filter) {
    params.set("filter", filter);
  }

  params.set("page", String(page));
  params.set("limit", String(limit));

  const response = await apiFetch(
    `${API_ENDPOINTS.eligibilityCheck.list}?${params}`,
  );

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.eligibilityListReadFailed);
  }

  if (!response.ok || result.status !== "OK") {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.eligibilityListFetchFailed,
    );
  }

  return result.data;
}

export async function fetchEligibilityCheckOptions() {
  const response = await apiFetch(API_ENDPOINTS.eligibilityCheck.options);

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.eligibilityOptionsReadFailed);
  }

  if (!response.ok || result.status !== "OK") {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.eligibilityOptionsFetchFailed,
    );
  }

  return result.data;
}

export async function searchEligibilityCheck(phone) {
  const response = await apiFetch(API_ENDPOINTS.eligibilityCheck.search, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
      ...getRequiredUsernameHeader(),
    },
    body: JSON.stringify({ phone }),
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.eligibilitySearchReadFailed);
  }

  if (!response.ok || result.status !== "OK") {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.eligibilityDetailsFetchFailed,
    );
  }

  return result.data;
}

export async function fetchLeadApplicationDedupe({ phone, pan }) {
  if (!API_ENV_URLS.dedupeCheck) {
    throw new Error(API_ERROR_MESSAGES.dedupeCheckUrlNotConfigured);
  }

  const payload = {};

  if (phone) {
    payload.phone = phone;
  }

  if (pan) {
    payload.pan = pan;
  }

  if (!payload.phone && !payload.pan) {
    return null;
  }

  const response = await fetch(API_ENV_URLS.dedupeCheck, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.dedupeCheckReadFailed);
  }

  if (!response.ok || result?.success !== true) {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.dedupeCheckFetchFailed,
    );
  }

  return result.data;
}

export async function fetchEligibilityResultForm({ contactId, phone }) {
  const params = new URLSearchParams();

  if (contactId) {
    params.set("contact_id", String(contactId));
  }

  if (phone) {
    params.set("phone", String(phone));
  }

  const response = await apiFetch(
    `${API_ENDPOINTS.eligibilityCheck.resultForm}?${params}`,
  );

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.eligibilityResultFormReadFailed);
  }

  if (!response.ok || result.status !== "OK") {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.eligibilityResultFormFetchFailed,
    );
  }

  return result.data;
}

export async function saveEligibilityCheckResult(payload) {
  const response = await apiFetch(API_ENDPOINTS.eligibilityCheck.result, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify(payload),
  });

  let result;

  try {
    result = await response.json();
  } catch {
    throw new Error(API_ERROR_MESSAGES.eligibilityResultSaveReadFailed);
  }

  if (!response.ok || result.status !== "OK") {
    throw new Error(
      result?.message || API_ERROR_MESSAGES.eligibilityResultSaveFailed,
    );
  }

  return result;
}
